import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.rvp-slider.swiper').forEach((slider) => {

		function initSlider(slider) {
			const options = JSON.parse(slider.getAttribute('data-swiper-options'));
			const slideCount = slider.querySelectorAll('.swiper-slide').length;

			if (slideCount <= options.slidesPerView.desktop) {
				slider.querySelector('.swiper-button-next').style.display = 'none';
				slider.querySelector('.swiper-button-prev').style.display = 'none';
			}

			new Swiper(slider, {
				loop: options.loop,
				speed: options.speed,
				centeredSlides: options.centeredSlides,
				grabCursor: options.grabCursor,
				effect: options.effect,
				autoplay: options.autoplay ? {
					delay: options.autoplayDelay,
					disableOnInteraction: false
				} : false,
				navigation: options.showArrows ? {
					nextEl: slider.querySelector('.swiper-button-next'),
					prevEl: slider.querySelector('.swiper-button-prev')
				} : false,
				pagination: options.showDots ? {
					el: slider.querySelector('.swiper-pagination'),
					clickable: true
				} : false,
				breakpoints: {
					0: {
						slidesPerView: options.slidesPerView.mobile,
						spaceBetween: options.spaceBetween.mobile,
						slidesPerView: 2.5 // force 2.5 on mobile
					},
					768: {
						slidesPerView: options.slidesPerView.tablet,
						spaceBetween: options.spaceBetween.tablet
					},
					1024: {
						slidesPerView: options.slidesPerView.desktop,
						spaceBetween: options.spaceBetween.desktop
					}
				},
				on: {
					init: () => {
						setTimeout(setEqualHeightForSwiperProducts, 50); // short delay for render
					},
					slideChange: () => {
						setTimeout(setEqualHeightForSwiperProducts, 50);
					}
				}
			});
		}



		function handleRVPSwiper() {
			const screenWidth = window.innerWidth;
			if ( screenWidth > 1024 ) {
				initSlider(slider);
			}
		}

		window.addEventListener('load', handleRVPSwiper);
		window.addEventListener('resize', handleRVPSwiper);
	});
});


// equal height
function setEqualHeightForSwiperProducts() {
	const wrappers = document.querySelectorAll('.swiper-wrapper');

	wrappers.forEach((wrapper) => {
		const slides = wrapper.querySelectorAll('.rvp-product');
		let maxHeight = 0;

		// Reset heights
		slides.forEach((slide) => {
			slide.style.height = 'auto';
		});

		// Find max height
		slides.forEach((slide) => {
			const height = slide.offsetHeight;
			if (height > maxHeight) maxHeight = height;
		});

		// Set max height
		slides.forEach((slide) => {
			slide.style.height = `${maxHeight}px`;
		});
	});
}
